import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { SwiperSlide, Swiper } from 'swiper/react';
import {
  useGetMovieDetailsQuery,
  useGetMoviePopularQuery,
  useGetPlayingMovieQuery,
  useGetTopRatedMovieQuery,
  useGetTrendingQuery,
  useGetUpComingMovieQuery,
} from '../../services/movieApi';
import MovieCard from './MovieCard';
import Select from 'react-select';
import HeroItem from './HeroItem';
import MovieTrailers from './MovieTrailers';
import Navbar from '../Navbar';
import MovieSimiliar from './MovieSimiliar';

const MovieDetails = ({ trending, cardMovies }) => {
  const { movieId } = useParams();

  const [mediaType, setMediaType] = useState('movie');
  const [timeType, setTimeType] = useState('day');
  const { data: detailMovie } = useGetMovieDetailsQuery({
    movieId: movieId == undefined ? '505642' : movieId,
  });

  const { data: trendingMovies } = useGetTrendingQuery({
    mediaType,
    timeType,
  });

  const { data: popularMovies } = useGetMoviePopularQuery();
  const { data: playingMovies } = useGetPlayingMovieQuery();
  const { data: topRatedMovies } = useGetTopRatedMovieQuery();
  const { data: upComingMovies } = useGetUpComingMovieQuery();

  const options = [
    {
      value: 'popularMovies',
      label: 'Popular',
    },
    {
      value: 'playingMovies',
      label: 'Playing Movies',
    },
    {
      value: 'topRatedMovies',
      label: 'Top Rated',
    },
    {
      value: 'upComingMovies',
      label: 'Up Coming',
    },
  ];
  const [selectedOption, setSelectedOption] = useState(options[0]);

  return (
    <>
      {trending ? (
        <div className="flex flex-col container mx-auto px-5 md:px-6">
          <div className="flex flex-row items-center justify-between w-full py-8">
            <p className="text-sm md:text-xl font-bold">Trending Movies</p>
            <div
              className={`flex flex-row ring-1 ring-white rounded-2xl text-sm md:text-base`}
            >
              <button
                className={`my-1 ml-1 px-4 rounded-2xl md:px-6 md:py-2 lg:px-8 ${
                  timeType === 'day' ? 'bg-red-500' : ''
                }`}
                onClick={() => setTimeType('day')}
              >
                Day
              </button>
              <button
                className={`my-1 mr-1 px-4 rounded-2xl md:px-6  md:py-2 lg:px-8 ${
                  timeType === 'week' ? 'bg-red-500' : ''
                }`}
                onClick={() => setTimeType('week')}
              >
                Week
              </button>
            </div>
          </div>
          <div className="movie-list">
            <Swiper grabCursor={true} spaceBetween={10} slidesPerView={'auto'}>
              {trendingMovies?.results.map((item, i) => (
                <SwiperSlide key={i}>
                  <MovieCard item={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      ) : cardMovies ? (
        <div className="flex flex-col container mx-auto px-5 md:px-6">
          <div className="flex flex-row items-center justify-between w-full py-8">
            <p className="text-sm md:text-xl font-bold">
              {selectedOption.value === 'popularMovies'
                ? 'Popular Movies'
                : selectedOption.value === 'playingMovies'
                ? 'Playing Movies'
                : selectedOption.value === 'topRatedMovies'
                ? 'Top Rated Movies'
                : 'Up Coming Movies'}
            </p>
            <Select
              defaultValue={options[0]}
              options={options}
              onChange={setSelectedOption}
              className="z-40 text-black"
            />
          </div>
          <div className="movie-list">
            <Swiper grabCursor={true} spaceBetween={10} slidesPerView={'auto'}>
              {selectedOption.value === 'popularMovies' ? (
                <>
                  {popularMovies?.results.map((item, i) => (
                    <SwiperSlide key={i}>
                      <MovieCard item={item} />
                    </SwiperSlide>
                  ))}
                </>
              ) : selectedOption.value === 'playingMovies' ? (
                <>
                  {playingMovies?.results.map((item, i) => (
                    <SwiperSlide key={i}>
                      <MovieCard item={item} />
                    </SwiperSlide>
                  ))}
                </>
              ) : selectedOption.value === 'topRatedMovies' ? (
                <>
                  {topRatedMovies?.results.map((item, i) => (
                    <SwiperSlide key={i}>
                      <MovieCard item={item} />
                    </SwiperSlide>
                  ))}
                </>
              ) : (
                <>
                  {upComingMovies?.results.map((item, i) => (
                    <SwiperSlide key={i}>
                      <MovieCard item={item} />
                    </SwiperSlide>
                  ))}
                </>
              )}
            </Swiper>
          </div>
        </div>
      ) : (
        <div className="bg-black text-white">
          <Navbar />
          <HeroItem items={detailMovie} movieId={movieId} />
          <MovieTrailers movieId={movieId} />
          <MovieSimiliar movieId={movieId} />
        </div>
      )}
    </>
  );
};

export default MovieDetails;
